export class GameVars {

    public static scaleY: number;
    public static gameData: GameData;
    public static paused: boolean;
    public static matchOver: boolean;
    public static difficulty: string;
    public static boardSize: {r: number, c: number};
    public static mines: number;
    public static time: number;
    public static flaggedCells: number;
    public static minesweeper: any;
    public static board: any;
    public static grid: CellData[][];
    public static tutorialFromSplash: boolean;

    public static areValidDomains(domains: string[]): boolean {

        if (domains.length === 0) {
            return true;
        }

        const hostname = window.location.hostname;
        const referrer = document.referrer;

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {

                if (referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static secondsToTime(seconds: number): string {

        const m = Math.floor(seconds / 60);
        const s = seconds % 60;

        let minutesString = m < 10 ? "0" + m.toString() : m.toString();
        let secondsString = s < 10 ? "0" + s.toString() : s.toString();

        return minutesString + ":" + secondsString;
    }

    public static formatTime(timeInSeconds: number): {str: string, h: string, m: string, s: string} {

        if (isNaN(timeInSeconds) || timeInSeconds > 24 * 3600) {
            return {str: "0:00:00", h: "00", m: "00", s: "00"};
        }

        const hours   = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds - (hours * 3600)) / 60);
        const seconds = timeInSeconds - (hours * 3600) - (minutes * 60);

        let h = hours.toString();
        let m = minutes.toString();
        let s = seconds.toString();

        if (hours < 10) {
            h = "0" + hours;
        }

        if (minutes < 10) { 
            m = "0" + minutes;
        }

        if (seconds < 10) {
            s = "0" + seconds;
        }

        return {str: h + ":" + m + ":" + s, h: h, m: m, s: s};
    }

    public static getSurroundingCells(p: {r: number, c: number}): {r: number, c: number}[] {

        const ret: {r: number, c: number}[] = [];
        const tmpArray: {r: number, c: number}[] = [];
        
        // arriba
        tmpArray.push({r: p.r - 1, c: p.c - 1});
        tmpArray.push({r: p.r - 1, c: p.c});
        tmpArray.push({r: p.r - 1, c: p.c + 1});

        // izquierda
        tmpArray.push({r: p.r, c: p.c - 1});
        // derecha
        tmpArray.push({r: p.r, c: p.c + 1});

        // abajo
        tmpArray.push({r: p.r + 1, c: p.c - 1});
        tmpArray.push({r: p.r + 1, c: p.c});
        tmpArray.push({r: p.r + 1, c: p.c + 1});

        // eliminar los que tengan indices negativos
        for (let i = 0; i < tmpArray.length; i ++) {
            if (tmpArray[i].r >= 0 && tmpArray[i].r < GameVars.boardSize.r && tmpArray[i].c >= 0 && tmpArray[i].c < GameVars.boardSize.c) {
                ret.push(tmpArray[i]);
            }
        }

        return ret;
    }
}
